import { Suspense } from "react";
import { ToastContainer } from "react-toastify";
import ThemeRoutes from "./routes/Router";
import { useRoutes } from "react-router-dom";
import Loader from "./components/layouts/loader/Loader";
import "react-toastify/dist/ReactToastify.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/style.scss'

function App() {
  const routing = useRoutes(ThemeRoutes);
  return (
    <Suspense fallback={<Loader />}>
      <div>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          limit={5}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        {routing}
      </div>
    </Suspense>
  );
}

export default App;
